import React from "react";
import { useTranslation } from "react-i18next";
import { DOC_DEFAULT } from "../../../../assets";
import FileCard from "../../../moleculas/FileCard";
import { MediaFileVM } from "../../../../types/viewModels/cmsPublic";

export interface NewsAttachmentsProps {
  files: MediaFileVM[];
}

const NewsAttachments: React.FC<NewsAttachmentsProps> = ({ files }) => {
  const { t } = useTranslation("news");

  if (files.length === 0) {
    return null;
  }

  return (
    <section className="w-100 my-5">
      <h2 className="h4">{t("attachments")}</h2>
      <hr className="custom-divider" />

      <div className="row w-100">
        {files.map((file, position) => (
          <div key={`${file.url}-${position}`} className="col-lg-6 col-12 mb-3">
            {/* FileCard ya abre el link en una pestaña nueva. */}
            <FileCard
              icon={DOC_DEFAULT}
              card={{ txt: file.name, link: file.url }}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default NewsAttachments;
